import React, { useState } from "react";
import styled from "styled-components";

import { UserDemographic } from "context/UserProfileContext";
import { useResource } from "hooks/useResource";

import { StyledTitleContainer } from "./StyledDataCustomizationContainer";
import { CustomCondition } from "./CustomCondition";
import { Icon, IconType } from "components/_icons/Icon";
import { Tooltip } from "components/Tooltip";
import { Text } from "components/Text";

import { DemographicCustomCondition } from "ts/sharing";
import { DemographicFilterHeader } from "ts/filters/demographicFilter";

type Props = {
  savedCustomConditions: DemographicCustomCondition[];
  analysisDemographicHeaders: DemographicFilterHeader[];
  userDemographics: UserDemographic[];
  showCustomConditionError: boolean;
  // function props
  updateDemographicCustomConditions?: (
    updatedCustomConditions: DemographicCustomCondition[]
  ) => void;
  handleHideCustomConditionError?: () => void;
};

export const CustomConditionSection = ({
  savedCustomConditions,
  analysisDemographicHeaders,
  userDemographics,
  showCustomConditionError,
  // function props
  updateDemographicCustomConditions,
  handleHideCustomConditionError,
}: Props) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const { getResource } = useResource();

  return (
    <div>
      <StyledTitleContainer>
        <b>
          <Text resource="sharing.permissionForm.customCondition.title" />
        </b>
        <div
          data-tooltip-id="custom-condition-tooltip"
          onMouseOver={() => setShowTooltip(true)}
          onMouseOut={() => setShowTooltip(false)}
        >
          <Icon type={IconType.info} size={10} />
          {showTooltip && (
            <Tooltip
              tooltipId="custom-condition-tooltip"
              content={getResource("sharing.permissionForm.customCondition.tooltip")}
            />
          )}
        </div>
      </StyledTitleContainer>
      <StyledCustomConditionContainer>
        {savedCustomConditions.map((cc, index) => (
          <CustomCondition
            key={index}
            index={index}
            customConditionDemographics={cc}
            savedCustomConditions={savedCustomConditions}
            analysisDemographicHeaders={analysisDemographicHeaders}
            userDemographics={userDemographics}
            showCustomConditionError={showCustomConditionError}
            updateDemographicCustomConditions={updateDemographicCustomConditions}
            handleHideCustomConditionError={handleHideCustomConditionError}
          />
        ))}
      </StyledCustomConditionContainer>
    </div>
  );
};

const StyledCustomConditionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
